import React from "react";
import IntelligenceWorkspaceShell from "./IntelligenceWorkspaceShell";

export default function AlertFlow({ children }) {
  return (
    <IntelligenceWorkspaceShell
      workspaceKey="alerts"
      eyebrow="Response intelligence"
      title="Alert Flow"
      description="How Response Designed moves through the escalation chain."
    >
      {children}
    </IntelligenceWorkspaceShell>
  );
}
